import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {AnimationHandler} from 'components/customer/Preview3D/animation/entity/AnimationHandler';

export const toggleMainBifoldDoorHandler = ({
    mesh,
    isRightLShape = false,
    pivotOffset = 0,
}: {
    mesh: THREE.Group<THREE.Object3DEventMap>;
    isRightLShape?: boolean;
    pivotOffset?: number;
}): AnimationHandler => {
    let initialRotation = {y: (90 * Math.PI) / 180};
    let openRotation = {y: 0};
    let closeRotation = {y: (90 * Math.PI) / 180};

    if (isRightLShape) {
        initialRotation = {y: mesh.rotation.y};
        openRotation = {y: (90 * Math.PI) / 180};
        closeRotation = {y: 0};
    }

    // Base position captured once so pivot compensation is relative to it.
    const baseX = mesh.position.x;
    const baseZ = mesh.position.z;
    const baseAngle = mesh.rotation.y;

    // Keep the inner edge (pivotOffset away from the mesh origin along local
    // X) fixed while the mesh rotates about Y. The origin traces an arc; we
    // counter-translate so the inner edge stays put.
    const applyPivot = (angle: number) => {
        mesh.rotation.y = angle;
        if (!pivotOffset) return;
        const dA = angle - baseAngle;
        mesh.position.x = baseX + pivotOffset * (1 - Math.cos(dA));
        mesh.position.z = baseZ - pivotOffset * Math.sin(dA);
    };

    const openDrawer = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const openTween = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(openRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    applyPivot(initialRotation.y);
                });

            openTween.start();
        });

    const closeTween = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const tween = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(closeRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    applyPivot(initialRotation.y);
                });

            tween.start();
        });

    return {
        open: [openDrawer],
        close: [closeTween],
    };
};
